import { createI18n } from 'vue-i18n'
import type { SupportedLocale } from '@/i18n/types'

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {},
})

// Each locale/domain JSON file becomes its own lazily-loadable chunk.
const localeModules = import.meta.glob<{ default: Record<string, string> }>('./locales/*/*.json')

const loadedLocales = new Set<SupportedLocale>()

export async function loadLocaleMessages(locale: SupportedLocale): Promise<void> {
  if (loadedLocales.has(locale)) return

  const matchingLoaders = Object.entries(localeModules).filter(([path]) =>
    path.startsWith(`./locales/${locale}/`),
  )

  const domainModules = await Promise.all(matchingLoaders.map(([, load]) => load()))

  const messages = domainModules.reduce<Record<string, string>>(
    (merged, module) => ({ ...merged, ...module.default }),
    {},
  )

  i18n.global.setLocaleMessage(locale, messages)
  loadedLocales.add(locale)
}

export async function setLocale(locale: SupportedLocale): Promise<void> {
  await loadLocaleMessages(locale)
  i18n.global.locale.value = locale
}
